// i18n.js
import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import translationEN from "./translations/en.json";
import translationMR from "./translations/mr.json";
import translationHI from "./translations/hi.json";
import translationVI from "./translations/vi.json";

const lang = localStorage.getItem("lang") || "en";

i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: translationEN,
    },
    mr: {
      translation: translationMR,
    },
    hi: {
      translation: translationHI,
    },
    vi: {
      translation: translationVI,
    },
  },
  lng: lang,
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
